var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.components),function(component,componentKey){return _c(componentKey,{tag:"container"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }